import { getAxiosInstance } from "../../../api";

export const exportEnquiry = async (params) => {
  const api = await getAxiosInstance();
  const response = await api.get(`admin/enquiry/export`, {
    params,
    responseType: "blob",
  });
  return response;
};
